import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetAllReferralReferralStatusEnum,
  ReferralControllerApi,
} from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  active?: boolean;
  archive?: boolean;
  referralIn?: boolean;
  referralFrom?: string;
  referralTo?: string;
  referralSpeciality?: string;
  referralDate?: string;
  gridSorting: GridSortItem[];
  referralStatus?: GetAllReferralReferralStatusEnum;
  searchString?: string;
  xTENANTID?: string;
  patientName?: string;
  patientId?: string;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author [Atish Bagate]
 */
export const useListReferral = ({
  pagination,
  archive,
  active,
  gridSorting,
  referralIn,
  referralFrom,
  referralTo,
  referralSpeciality,
  referralDate,
  referralStatus,
  searchString,
  patientName,
  patientId,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "collaboration-referral-list",
      pageIndex,
      pagination.pageSize,
      gridSorting,
      sortData?.field,
      sortData?.sort ?? undefined,
      active,
      archive,
      referralFrom,
      referralTo,
      referralSpeciality,
      referralDate,
      referralStatus,
      searchString,
      referralIn,
      patientName,
      patientId,
      xTENANTID,
    ],

    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled,
    queryFn: async () =>
      await new ReferralControllerApi(getConfigObject())
        .getAllReferral(
          pageIndex, //page
          pagination.pageSize, //size
          sortData?.field, // sortBy
          sortData?.sort ?? undefined, // sortDirection
          archive,
          active, // active
          referralIn,
          referralFrom,
          referralTo,
          referralSpeciality,
          referralDate,
          referralStatus,
          searchString,
          patientName,
          patientId,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
